'use es6';

import makeSaveActions from 'ContentEditorUI/js/redux/actions/makeSaveActions';
import { getSaveData } from '../selectors/saveSelectors';
import bus from 'ContentEditorUI/coffee/lib/eventBus';
import makeWaitForPendingInpageUpdates from 'ContentEditorUI/utils/makeWaitForPendingInpageUpdates';
import { clearSaveAlerts } from 'ContentEditorUI/utils/errorUtils';
const modifySaveQuery = query => {
  return Object.assign({}, query, {
    serialize_modules_in_rich_text: true
  });
};
const actions = makeSaveActions({
  serialize: getSaveData,
  wait: makeWaitForPendingInpageUpdates(bus),
  modifySaveQuery
});
export const save = opts => {
  clearSaveAlerts();
  return actions.save(opts);
};
export const autoSave = actions.autoSave;
export const autoSaveDebounced = actions.autoSaveDebounced;